import React from 'react';

import PageLayout from '../../../components/PageLayout';

import Portfolio from './Portfolio';

async function action() {
  return {
    title: 'Flux Tech\'s Software Portfolio',
    description: "View projects that we've worked on over the past few years.",
    chunks: ['portfolio'],
    component: (
      <PageLayout>
        <Portfolio key="projects" />
      </PageLayout>
    ),
  };
}

export default action;
